import { CIRCLES_API } from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import fetchRetry from '../fetch_retry';
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_KEY, SITE_URL, SHARING_BOX_URL_PIECES } from '../../config';

export async function checkoutProducts(products, pool_id) {
  const stripePromise = loadStripe(STRIPE_KEY);
  const stripe = await stripePromise;

  await stripe.redirectToCheckout({
    lineItems: products,
    mode: "subscription",
    successUrl: `${SITE_URL}/sharing-box-success/${pool_id}`,
    cancelUrl: `${SITE_URL}/sharing-box/${pool_id}`,
  });
}

export function fetchProducts(pool_id, params) {
  return function (dispatch, getState) {

    dispatch(ActionCreators.fetchingPrypoolProducts());
    let url = `${CIRCLES_API}/prypool-products/${pool_id}`;

    let request_options = {
      headers: { "Content-Type": "application/json" }
    }
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingPrypoolProducts(error));
        }
      )
      .then(response => {
        if ('message' in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.prypool_products.fetch", "error"));
          dispatch(ActionCreators.errorFetchingPrypoolProducts(response.message));
        } else {
          dispatch(ActionCreators.fetchedPrypoolProducts(response));
        }
      });
  };
}

export function fetchSharingBox(boxId, params) {
  return function (dispatch, getState) {

    dispatch(ActionCreators.fetchingSharingBox());
    const url = `${SHARING_BOX_URL_PIECES.url}${boxId}${SHARING_BOX_URL_PIECES.query}`;

    let request_options = {
      headers: { "Content-Type": "application/json" }
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingPrypoolProducts(error));
        }
      )
      .then(response => {
        if ('message' in response && (response.message === "Internal Server Error" || response.message === "object not found")) {
          dispatch(pushNotification("errors.prypool_products.fetch", "error"));
          dispatch(ActionCreators.errorFetchingPrypoolProducts(response.message));
        } else {
          dispatch(ActionCreators.fetchedSharingBox(response));
        }
      });
  };
}


export function redirectToCheckout(payload) {
  return function (dispatch, getState) {
    dispatch(fetchCheckoutSessionId(payload)).then(
      success => {
        success.session && checkoutProductsWithSessionId(success.session);
      },
      error => {

      }
    )
  }
}

export async function checkoutProductsWithSessionId(sessionId) {
  const stripePromise = loadStripe(STRIPE_KEY);
  const stripe = await stripePromise;
  await stripe.redirectToCheckout({ sessionId });
}

export function fetchCheckoutSessionId(payload) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingSessionId());

    let url = `${CIRCLES_API}/prypool-products/checkout-session`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    }

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }
    return new Promise((resolve, reject) => {
      fetchRetry(url, request_options, dispatch, getState)
        .then(
          response => response.json(),
          error => {
            dispatch(ActionCreators.errorFetchingSessionId(error));
          }
        )
        .then(response => {
          if ('message' in response || 'error' in response) {
            dispatch(pushNotification("errors.sharing_box.checkout_session", "error"));
            dispatch(ActionCreators.errorFetchingSessionId(response.message));
            reject();
          } else {
            dispatch(ActionCreators.fetchedSessionId(response));
            resolve(response);
          }
        });
    })

  };
}

export function redirectRentalCheckout(payload) {
  return function (dispatch, getState) {
    dispatch(fetchCheckoutRentalSession(payload)).then(
      response => {
        response.session && checkoutProductsWithSessionId(response.session);
      },
      error => {

      }
    )
  }
}

export function fetchCheckoutRentalSession(payload) {
  return function (dispatch, getState) {

    dispatch(ActionCreators.fetchingPrypoolProducts());
    let url = `${CIRCLES_API}/prypool-products/checkout-rental-session`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    }
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(pushNotification("errors.rental_session.fetch", "error"));
        }
      )
  };
}